/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index help-button to autogenerate all the components and extensions
 * Used by "prepareHelpButtons"
 */

import HelpButton from './help-button/HelpButton'
export * from './help-button/HelpButton'
export default HelpButton
